import styled, { css } from 'styled-components';
import { TableCell, TableCellProps } from '@mui/material';
import { MoreHoriz as MoreHorizIcon } from '@mui/icons-material';
import { CustomHeaderSelect, CustomHeaderSelectProps } from '../select';
import { IconButton } from '../button';

export const TableIconCell = styled(TableCell)`
  & > * {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }

  & > .MuiSvgIcon-root {
    display: grid;
    transform: none;
  }
`;

const TableIconsCellBase = styled.div<{ withGap?: boolean }>`
  display: grid;
  grid-auto-columns: max-content;
  grid-auto-flow: column;
  align-items: center;

  ${(props) =>
    props.withGap &&
    css`
      grid-column-gap: var(--spacing-2);
    `}
`;

interface TableIconsCellProps extends TableCellProps {
  withGap?: boolean;
}

export const TableIconsCell = ({ withGap, ...props }: TableIconsCellProps) => {
  return (
    <TableCell {...props}>
      <TableIconsCellBase withGap={withGap}>{props.children}</TableIconsCellBase>
    </TableCell>
  );
};

export const TableDots: React.FC<CustomHeaderSelectProps> = (props: CustomHeaderSelectProps) => {
  return (
    <CustomHeaderSelect
      HeaderComponent={
        <IconButton
          onClick={(e: any) => {
            e.stopPropagation();
            props.onToggle && props.onToggle();
          }}
        >
          <MoreHorizIcon />
        </IconButton>
      }
      {...props}
    />
  );
};
